/**
 *  @since: 2020-05-15
 *  @author: tams_dev1
 */

import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  txtBlockMailAddrListUrl: '/api/op/as/block-mail/profiles',
  txtBlockMailAddrListCommitUrl: '/api/op/as-block-mail-profiles',
  // 선택한 row 데이터
  rowSelectItems: {},
  rowSelectItemsSubTable: {},
  getBlockMailAddrListData: [],
  getMailAddrData: []
})

export const mutations = {
  clearStore: (state) => {
    state.rowSelectItems = {}
    state.rowSelectItemsSubTable = {}
    state.getBlockMailAddrListData = []
    state.getMailAddrData = []
  },
  setRowSelectItems: (state, data) => {
    state.rowSelectItems = _.cloneDeep(data)
  },
  setRowSelectItemsSubTable: (state, data) => {
    state.rowSelectItemsSubTable = _.cloneDeep(data)
  },
  subTableHeaderMutation: (state, data) => {
    state.getMailAddrData = _.map(state.getMailAddrData, (item) => {
      item.block_mail_use = data
      return item
    })
  },
  getBlockMailAddrListDataAction: (state, data) => {
    state.getBlockMailAddrListData = _.cloneDeep(data)
  },
  addBlockMailAddrListDataAction: (state, data) => {
    state.getBlockMailAddrListData.push(data)
  },
  editBlockMailAddrListDataAction: (state, data) => {
    state.getBlockMailAddrListData = _.map(state.getBlockMailAddrListData, (item) => {
      if (item.block_mail_list_id === data.block_mail_list_id) {
        item.block_mail_list_uname = _.cloneDeep(data.block_mail_list_uname)
        item.block_mail_list_desc = _.cloneDeep(data.block_mail_list_desc)
      }
      return item
    })
  },
  getMailAddrDataAction: (state, data) => {
    state.getMailAddrData = _.cloneDeep(data)
  },
  addSubTable: (state, data) => {
    state.getMailAddrData.push(data)
  },
  editSubTable: (state, data) => {
    state.getMailAddrData = _.map(state.getMailAddrData, (item) => {
      if (item.block_mail_id === data.block_mail_id) {
        item.block_mail_use = _.cloneDeep(data.block_mail_use)
        item.block_mail_direct = _.cloneDeep(data.block_mail_direct)
        item.block_mail_mail_addr = _.cloneDeep(data.block_mail_mail_addr)
        item.block_mail_ptrn_type = _.cloneDeep(data.block_mail_ptrn_type)
      }
      return item
    })
  }
}

export const actions = {
  // 차단메일목록 조회
  async getBlockMailAddrListDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtBlockMailAddrListUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getBlockMailAddrListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 차단메일목록 추가
  async addBlockMailAddrListDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(state.txtBlockMailAddrListUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addBlockMailAddrListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 차단메일목록 수정
  async editBlockMailAddrListDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtBlockMailAddrListUrl}/${state.rowSelectItems[0].block_mail_list_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editBlockMailAddrListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 차단메일목록 삭제
  async delBlockMailAddrListDataAction ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItems.length > 1) {
      isMulty = true
      state.rowSelectItems.forEach((item) => {
        idList.push({'block_mail_list_id': item.block_mail_list_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.txtBlockMailAddrListUrl, {data: {items: idList}}, {failAlert: false}) : await this.$axios.$delete(`${state.txtBlockMailAddrListUrl}/${state.rowSelectItems[0].block_mail_list_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 차단메일 메일목록 조회
  async getMailAddrDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtBlockMailAddrListUrl}/${state.rowSelectItems[0].block_mail_list_id}/items`)
      return resultFactory(commit, {length: null, data: data, action: 'getMailAddrDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 차단메일 메일목록 추가
  async addSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.txtBlockMailAddrListUrl}/${state.rowSelectItems[0].block_mail_list_id}/items`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addSubTable', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 차단메일 메일목록 수정
  async editSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtBlockMailAddrListUrl}/${state.rowSelectItems[0].block_mail_list_id}/items/${state.rowSelectItemsSubTable[0].block_mail_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editSubTable', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 차단메일 일괄수정
  async editAllSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtBlockMailAddrListUrl}/${state.rowSelectItems[0].block_mail_list_id}/items`, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 차단메일 메일목록 삭제
  async delSubTable ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItemsSubTable.length > 1) {
      isMulty = true
      state.rowSelectItemsSubTable.forEach((item) => {
        idList.push({'block_mail_list_id': state.rowSelectItems[0].block_mail_list_id, 'block_mail_id': item.block_mail_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.txtBlockMailAddrListUrl}/${state.rowSelectItems[0].block_mail_list_id}/items`, {data: {items: idList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.txtBlockMailAddrListUrl}/${state.rowSelectItems[0].block_mail_list_id}/items/${state.rowSelectItemsSubTable[0].block_mail_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 차단메일목록 적용/취소
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.txtBlockMailAddrListCommitUrl}/${type}`, null, msg)
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
